import { Collection } from "typings";
import produce from "immer";
import { ServerState } from "../ServerState";
import { CollectionActions } from "./action";


export interface State extends ServerState<Collection>
{
}

const initialState: State = {
    byId: {}
};


const reducer = (state = initialState, action: CollectionActions): State => produce(state, draft =>
{
   if (action.type === "LOAD_COLLECTION_SUCCESS")
   {
        const { collections } = action;
        for (const collection of collections)
        {
            draft.byId[collection.id] = collection;
        }
   }
   if (action.type === "REMOVE_COLLECTION")
   {
        const { id } = action;
        delete draft.byId[id];
   }
});

export const getCollections = (state: State): Collection[] => Object.keys(state.byId).map(key => state.byId[key]);

export const getCollection = (state: State, collectionId: string): Collection => state.byId[collectionId];

export default reducer;


// WEBPACK FOOTER //
// ./src/state/collection/index.ts